import { FOOTER_URLS } from '@qureos/statics/job-application'

import {
  Discord,
  Facebook,
  Instagram,
  LinkedIn,
  QureosWhiteLogo,
  Tiktok,
  Twitter,
  Youtube
} from '@qureos/assets'

interface Props {
  footerData?: {
    heading: string
    data: {
      link: string
      title: string
    }[]
  }[]
}

export const HireFooter: React.FC<Props> = ({ footerData }) => {
  return (
    <div className="pt-5 md:block hidden w-screen">
      <div className="bg-black text-white py-5 text-xs">
        <div className="flex justify-start gap-12">
          <div className="w-1/8 pt-5 pl-24">
            <img className="inline-block" src={QureosWhiteLogo} alt="Qureos" />
          </div>
          <div className="w-7/8 flex justify-evenly gap-4 mx-4">
            {footerData.map(item => (
              <div style={{ width: '100%' }} key={item.heading}>
                <span className="font-semibold">{item.heading}</span>
                <ul className="mt-4 flex flex-col gap-y-2">
                  {item?.data?.map(i => (
                    <li key={i.link + i.title}>
                      <a href={i.link} className="hover:text-[#0D74FF]">
                        {i.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <div style={{ width: '100%' }}>
              <span className="font-semibold">Contacts</span>
              <ul className="mt-4 flex flex-col gap-y-2">
                <li>
                  <a
                    href={FOOTER_URLS.QUREOS_SUPPORT}
                    className="hover:text-[#0D74FF]">
                    Qureos Support
                  </a>
                </li>
                <li>
                  <a href={FOOTER_URLS.ABOUT} className="hover:text-[#0D74FF]">
                    About
                  </a>
                </li>
                <li>
                  <a
                    href={FOOTER_URLS.PROJECTS}
                    className="hover:text-[#0D74FF]">
                    Projects
                  </a>
                </li>
                <li>
                  <a
                    href={FOOTER_URLS.SUBMIT_GUEST_BLOGS}
                    className="hover:text-[#0D74FF]">
                    Submit Guest Blog
                  </a>
                </li>
                <li className="flex flex-wrap gap-2 w-10/12">
                  <img
                    src={Instagram}
                    width="30px"
                    alt="social-icon"
                    className="bg-gray-600 rounded-md p-1"
                    onClick={() => window.open(FOOTER_URLS.INSTAGRAM, '_blank')}
                  />
                  <img
                    src={Twitter}
                    width="30px"
                    alt="social-icon"
                    className="bg-gray-600 rounded-md p-1"
                    onClick={() => window.open(FOOTER_URLS.TWITTER, '_blank')}
                  />
                  <img
                    src={LinkedIn}
                    width="30px"
                    alt="social-icon"
                    className="bg-gray-600 rounded-md p-1"
                    onClick={() => window.open(FOOTER_URLS.LINKEDIN, '_blank')}
                  />
                  <img
                    src={Youtube}
                    width="30px"
                    alt="social-icon"
                    className="bg-gray-600 rounded-md p-1"
                    onClick={() => window.open(FOOTER_URLS.YOUTUBE, '_blank')}
                  />
                  <img
                    src={Tiktok}
                    width="30px"
                    alt="social-icon"
                    className="bg-gray-600 rounded-md p-1"
                    onClick={() => window.open(FOOTER_URLS.TIKTOK, '_blank')}
                  />
                  <img
                    src={Facebook}
                    width="30px"
                    alt="social-icon"
                    className="bg-gray-600 rounded-md p-1"
                    onClick={() => window.open(FOOTER_URLS.FACEBOOK, '_blank')}
                  />
                  <img
                    src={Discord}
                    width="30px"
                    alt="social-icon"
                    className="bg-gray-600 rounded-md p-1"
                    onClick={() => window.open(FOOTER_URLS.DISCORD, '_blank')}
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="p-3 text-xs w-full bg-black bg-opacity-80 flex gap-2 justify-end text-gray-400">
        <span className="w-8/12"> @ 2023 Qureos. All rights reserved.</span>
        <div className="w-3/12 flex gap-2 ">
          <span className="w-min whitespace-nowrap">
            <a href={FOOTER_URLS.TERM_OF_USE}>Terms of use</a>
          </span>
          <span className="w-min whitespace-nowrap">
            <a href={FOOTER_URLS.PRIVACY_POLICY}>Privacy policy</a>
          </span>
        </div>
      </div>
    </div>
  )
}
